export const customTheme = {
    palette: {
        type: "light",
        primary: {
            main: "#EE553B",
            light: "#EE553B",
            dark: "#EE553B",
            contrastText: "#FFFFFF"
        },
    },
    typography: {
        fontWeightLight: 600,
        fontSize: 14,
        fontFamily: "Open Sans, sans-serif",
    },
    overrides: {
        MuiInputBase: {
            input: {
                fontSize: "14px",
            },
        },
        // Helper Text error message margin remove
        MuiFormHelperText: {
            contained: {
                marginLeft: 0,
                marginRight: 0,
            },
        },
        MuiTextField: {
            root: {
                "& label": {
                    color: "#A0A0A0",
                    fontSize: "14px",
                },
                "& label.Mui-focused": {
                    color: "#EE553B",
                },
                "& label.MuiInputLabel-shrink": {
                    fontSize: "16px",
                },
                "& .MuiOutlinedInput-root": {
                    border: "1px",
                    borderColor: "#E1E1E1",
                    borderRadius: "4px",
                    "&.Mui-focused fieldset": {
                        borderColor: "#EE553B !important",
                    },
                },
                "& ::placeholder": {
                    color: "#CDD0D2",
                    fontSize: "14px",
                    opacity: 1,
                },
                "& .MuiOutlinedInput-adornedEnd": {
                    padding: "0",
                },
            },
        },
        MuiFormControl: {
            root: {
                "& label": {
                    color: "#A0A0A0",
                    fontSize: "14px",
                },
                "& label.Mui-focused": {
                    color: "#EE553B",
                },
                "& label.MuiInputLabel-shrink": {
                    fontSize: "16px",
                },
                "& .MuiSelect-icon": {
                    color: "#A0A0A0",
                },
            },
        },
        MuiSelect: {
            root: {
                "& .MuiOutlinedInput-root": {
                    border: "1px",
                    borderColor: "#E1E1E1",
                    borderRadius: "4px",
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#EE553B !important",
                    },
                },
            },
        },
        MuiAutocomplete: {
            root: {
                '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
                    paddingLeft: '10.5px',
                },
            },
            clearIndicator: {
                color: "#A0A0A0",
            },
            popupIndicator: {
                color: "#A0A0A0",
            },
        },
        MuiButton: {
            root: {
                textTransform: "none",
            },
            containedPrimary: {
                "&:hover, &:active": {
                    backgroundColor: "#EE553B",
                    color: "#FFFFFF",
                },
            },
            outlinedPrimary: {
                "&:hover, &:active": {
                    borderColor: "#EE553B",
                    color: "#EE553B",
                },
            },
        },
        MuiIconButton: {
            root: {
                color: "#EE553B",
                "&:hover, &:active": {
                    color: "#EE553B",
                },
            },
        },
    },
};